<template>
  <div class="fileuploader">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <div class="container-fluid padding-left-3Perc margin-bottom-2Perc">
        <file-uploader-searchbar @searchResults="getSearchResults" @refreshList="getAllFiles"></file-uploader-searchbar>
        <div class="height-150px">
          <file-upload-list class="width-17Perc" v-for="fileRespoObj in getAllFilesValues" :key="fileRespoObj.FileId" v-bind:fileObj="fileRespoObj" @refreshList="getAllFiles"></file-upload-list>
        </div>
        
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>  
  </div>
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import FileUploaderSearchBar from '@/components/FileUploaderSearchBar'
import FileUploadList from '@/components/FileUploadList'
import { fileUploadService } from '@/server-util/file-upload-service'
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import CopyrightElement from '@/components/CopyrightElement'
import ErrorPage from '@/pages/Error'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.getAllFiles()
    this.trackPageLoad()
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      fileResp: [],
      showSpinner: false
    }
  },
  components: {
    'file-uploader-searchbar': FileUploaderSearchBar,
    'file-upload-list': FileUploadList,
    'Copyright-Element': CopyrightElement,
    'error-page': ErrorPage,
    'loader': Loader,
    'alert-box': AlertBox
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    getSearchResults (value) {
      // AK: In order to get search Results entered in Search box
      this.fileResp = value
    },
    getAllFiles: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== '' || storeObj.state.access_token !== null) {
        // AK: Check weather Course List is already present on not
        if (storeObj.state.fileRepositoryList.length === 0) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
        } else {
          this.fileResp = storeObj.state.fileRepositoryList
        }
        fileUploadService.listAllFiles(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              var responseArr = []
              for (var i = 0; i < responseObj.data.length; i++) {
                var obj = {
                  FileId: responseObj.data[i].FileId,
                  FileName: responseObj.data[i].FileName,
                  Description: responseObj.data[i].Description,
                  FileType: responseObj.data[i].FileType,
                  FileUrl: responseObj.data[i].FileUrl,
                  CreatedTS: responseObj.data[i].CreatedTS,
                  UpdatedTS: responseObj.data[i].UpdatedTS
                }
                responseArr.push(obj)
              }

              // AK: Store given file Repository List
              storeObj.state.fileRepositoryList = responseArr
              this.fileResp = responseArr
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
              // console.log('getAllFiles Response >>> ' + JSON.stringify(storeObj.state.fileRepositoryList))
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Hide Spinner if its showing to user
            if (this.$store.state.isLoading === true) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE GET FILE REPOSITORY LIST OPERATION')
      }
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load File Uploader Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Generic,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'MANAGE CONTENT',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    }
  },
  computed: {
    getAllFilesValues: {
      get: function () {
        return this.fileResp
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'fileuploader'
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.fileuploader {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.width-17Perc{
  width:17%;
}
.padding-left-3Perc{
  padding-left: 3%;
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
.height-150px{
  height: 150px;
}
</style>


// WEBPACK FOOTER //
// src/pages/FileUploader.vue